import { render, staticRenderFns } from "./StallionCampagne.vue?vue&type=template&id=cc3d5770&"
import script from "./StallionCampagne.vue?vue&type=script&lang=js&"
export * from "./StallionCampagne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports